import React, { useEffect } from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return { ...ItemsConfig, componentId: 'processes', entity: 'process', filtersFetchData: { process: { isAlive: true } } };
};

const Processes = props => {
  const defaultProps = {
    flavorId: 'process',
    title: 'Processes',
    nameColumns: [
      'defaultLocation',
      'currentLocation',
      'lastPosition',
      'startScheduledAndReal',
      'endScheduledAndReal',
      'itemsContent',
    ],
  };

  return <Items configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default Processes;
